import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import { flexyAlmacenesService } from '../../../api/flexyAlmacenesService'
import { DEFAULT_FLEXY_IDEMPRESA } from '../../../constants/flexyStock'
import type { FlexyAlmacen } from '../../../types/flexyAlmacenes'
import { extractAxiosApiErrorMessage } from '../../../utils/apiErrorMessage'

export function useFlexyAlmacenes(
  idempresa: number = DEFAULT_FLEXY_IDEMPRESA,
  enabled = true
) {
  const [almacenes, setAlmacenes] = useState<FlexyAlmacen[]>([])
  const [isLoading, setIsLoading] = useState(enabled)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!enabled) {
      setIsLoading(false)
      return
    }

    let cancelled = false

    const load = async () => {
      setIsLoading(true)
      setError(null)

      try {
        const rows = await flexyAlmacenesService.getAlmacenes({
          idempresa,
          activo: '1'
        })
        if (!cancelled) setAlmacenes(rows)
      } catch (err) {
        if (!cancelled) {
          const message = extractAxiosApiErrorMessage(err, 'Error al cargar almacenes')
          setAlmacenes([])
          setError(message)
          toast.error(message)
        }
      } finally {
        if (!cancelled) setIsLoading(false)
      }
    }

    load()

    return () => {
      cancelled = true
    }
  }, [idempresa, enabled])

  return { almacenes, isLoading, error }
}
